module.exports = __webpack_public_path__ + "img/team.f330f648.png";